export const videoHasAudio = (mpd) =>
  mpd?.mPD?.period?.adaptationSet.length >= 2 || false;
